import React, { useEffect, useState } from "react";
import { corefetch } from "../../../Util/axios_core_helper";

const FunFactSection = () => {
  const [data, setData] = useState([]);

  const fetchHighlights = async () => {
    try {
      const response = await corefetch("HighlightsAwards/GetHighlights");
      if (response) {
        setData(response);
      } else {
        setData([]);
        console.error("Failed to fetch highlights data");
      }
    } catch (error) {
      setData([]);
      console.error("Error fetching highlights:", error);
    }
  };

  useEffect(() => {
    fetchHighlights();
  }, []);

  useEffect(() => {
    if (data?.length) {
      setTimeout(() => {
      $(".highlight-slider").owlCarousel({
        autoplay: true,
        smartSpeed: 300,
        margin: 0.5,
        loop: true,
        lazyLoad: true,
        autoplayHoverPause: true,
        dots: false,
        arrows: false,
        nav: false,
        center: true,
        autoWidth: false,
        autoHeight: true,
        items: 5,
        navText: [
          '<i class="ti-arrow-left"></i>',
          '<i class="ti-arrow-right"></i>',
        ],
        responsive: {
          0: {
            items: 1,
            dots: false,
            arrows: false,
            nav: false,
          },

          575: {
            items: 1,
          },
          767: {
            items: 1,
            dots: false,
          },

          992: {
            items: 5,
            dots: false,
          },

          1200: {
            items: 5,
          },
        },
      });
      document.querySelectorAll(".odometer").forEach((el) => {
        const count = el.getAttribute("data-count");
        el.innerHTML = count;
      });
    }, 100);
      
    }
  }, [JSON.stringify(data)]);

  const formatCount = (count) => {
    if (count >= 1_000_000_000) {
      return (count / 1_000_000_000).toFixed(count % 1_000_000_000 === 0 ? 0 : 1) + "B";
    } else if (count >= 1_000_000) {
      return (count / 1_000_000).toFixed(count % 1_000_000 === 0 ? 0 : 1) + "M";
    } else if (count >= 1_000) {
      return (count / 1_000).toFixed(count % 1_000 === 0 ? 0 : 1) + "k";
    }
    return count.toString();
  };

  return (
    data?.length > 0 && (
      <section className="wpo-fun-fact-section section-padding" style={{ height: "230px" }}>
        <div className="container">
          <div className="row">
            <div className="col col-xs-12">
              <div className="wpo-fun-fact-grids highlight-slider owl-carousel" style={{ height: "60px" }}>
                {data.map((item, index) => (
                  <div key={item.highlightsID} className="grid">
                    <div className="info">
                      <h3>
                        <span className="odometer" data-count={formatCount(item.count)}>00</span>+
                      </h3>
                      <p>{item.title}</p>
                    </div>
                    <div className="flower">
                      <img
                        src={`assets/images/funfact/${(index % 3) + 1}.png`}
                        alt={item.title}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  );
};

export default FunFactSection;
